import axios from 'axios';

export default axios.create({
  baseURL: `http://gwosko8.64.227.153.133.sslip.io/`,
});